import { devtools } from 'config/devtools'
import { PromoScenarioTabsCodes } from 'modules/promoDataSources/interfaces/common'
import { create } from 'zustand'

import { UseCurrentPromoScenarioTab } from './types'

export const useCurrentPromoScenarioTab = create<UseCurrentPromoScenarioTab>()(
  devtools(
    (set) => ({
      currentTab: PromoScenarioTabsCodes.Input,
      setCurrentTab: (currentTab) => set({ currentTab }),
    }),
    {
      store: 'currentPromoScenarioTab',
    },
  ),
)
